import React, { useState, useEffect, useContext } from 'react';
import './Checkout.css';
import axios from 'axios';
import { UserContext } from "./OrderPlacement/OrderContext";
import { useNavigate } from 'react-router-dom';

export default function Checkout() {

    const { setOrderMSG, setOrderCode } = useContext(UserContext);
    const navigate = useNavigate();

    // ✅ Load cart safely
    const storedCart = JSON.parse(localStorage.getItem('Added')) || [];

    const [subtotal] = useState(
        storedCart.reduce((total, item) => total + (item.price * item.quantity), 0)
    );

    const adiscount = JSON.parse(localStorage.getItem("justDiscount")) || 0;

    const [deliveryfee, setDeliveryfee] = useState(0);

    // ✅ User state
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [name, setName] = useState("");
    const [number, setNumber] = useState("");
    const [email, setEmail] = useState("");

    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [country, setCountry] = useState('');

    // ✅ Load user from localStorage once
    useEffect(() => {
        const storedName = localStorage.getItem("userName");
        const storedPhone = localStorage.getItem("userPhone");
        const storedEmail = localStorage.getItem("userEmail");

        if (storedName || storedPhone || storedEmail) {
            setIsLoggedIn(true);
            setName(storedName || "");
            setNumber(storedPhone || "");
            setEmail(storedEmail || "");
        }
    }, []);

    // ✅ Delivery logic
    const handledelivery = (e) => {
        const deliveryCity = e.target.value || '';

        if (deliveryCity.toLowerCase() === "karachi") {
            setDeliveryfee(200);
        } else {
            setDeliveryfee(320);
        }
    };

    // ✅ Order function
    const makeOrder = async (e) => {
        e.preventDefault();

        if (!name || !number || !email || !address || !city || !postalCode || !country) {
            alert('All fields are required!');
            return;
        }

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_URL}/api/MakeOrder/dbms`,
                {
                    name,
                    whatsapp: number,
                    email,
                    address,
                    city,
                    postalCode,
                    country,
                    orderDetails: storedCart,
                    discountCode: JSON.parse(localStorage.getItem("SelectedCoupon"))
                }
            );

            if (res.data.success) {
                console.log(res.data.msg);

                setOrderMSG(res.data.msg);
                setOrderCode(res.data.orderCode);
                 console.log(localStorage.getItem('Added'))
                navigate('/Inform-User');
                localStorage.removeItem("Added");
                localStorage.removeItem("justDiscount");
                localStorage.removeItem("SelectedCoupon");
            }

        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div>
            <form className="formpayment" onSubmit={makeOrder}>

                <label>
                    Full Name:
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        disabled={isLoggedIn}
                        style={{
                            background: isLoggedIn ? 'rgba(92,91,95,0.4)' : 'transparent'
                        }}
                        required
                    />
                </label>

                <label>
                    Whatsapp Number:
                    <input
                        type="text"
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        disabled={isLoggedIn}
                        style={{
                            background: isLoggedIn ? 'rgba(92,91,95,0.4)' : 'transparent'
                        }}
                        required
                    />
                </label>

                <label>
                    Email:
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={isLoggedIn}
                        style={{
                            background: isLoggedIn ? 'rgba(92,91,95,0.4)' : 'transparent'
                        }}
                        required
                    />
                </label>

                <label>
                    Address:
                    <input type="text" onChange={(e) => setAddress(e.target.value)} required />
                </label>

                <label>
                    City:
                    <input
                        type="text"
                        onChange={(e) => {
                            handledelivery(e);
                            setCity(e.target.value);
                        }}
                        required
                    />
                </label>

                <label>
                    Postal Code:
                    <input type="text" onChange={(e) => setPostalCode(e.target.value)} required />
                </label>

                <label>
                    Country:
                    <input type="text" onChange={(e) => setCountry(e.target.value)} required />
                </label>

                <label>
                    Payment Method:
                    <select required>
                        <option value="cod">Cash on Delivery</option>
                    </select>
                </label>

                <div className="finalcalulation">
                    <p>Subtotal: Rs. {subtotal}</p>
                    <p>Discount: Rs. -{adiscount}</p>
                    <p>Delivery Fee: Rs. {deliveryfee}</p>
                    <h2>Total: Rs. {subtotal - adiscount + deliveryfee}</h2>
                </div>

                <button type="submit">Place Order</button>

            </form>
        </div>
    );
}